export const getAlerts = (state) => state.alerts?.active || [];
